import { StateCreator } from 'zustand';
import { FormFieldsSlice, FormSelectedData } from './formFieldsTypes';

type ImmerStateCreator<T> = StateCreator<
  T,
  [["zustand/immer", never], never],
  [],
  T
>;

const initialState = {
    section: {  
        name: null,
        size: null,
        id: null,
        code: null,
    },
    color: { name: null, id: null },
    size: { name: null, id: null },
    condition: { name: null, id: null },
    itemName: null,
    price: null,
    description: null,
    yearOfPurchase: null,
    checkboxTerms: null,  
}

export const createFieldsSlice: ImmerStateCreator<FormFieldsSlice> = (set) => ({
    zustandSync: false, 
    createFields: initialState,
    editFields: initialState,
    ADD_CREATE_FIELDS: (newFields: FormSelectedData) => {
        set((state) => {
            state.createFields = {
                ...state.createFields,
                ...newFields,
            };
        }, false, 'ADD_CREATE_FIELDS')
    },
    ADD_EDIT_FIELDS: (newFields: FormSelectedData) => {
            set((state) => {
                state.editFields = {
                    ...state.editFields,
                    ...newFields,
                };
            }, false, 'ADD_EDIT_FIELDS')
    },
    SYNC_DATA: (newState: boolean) => {
        set((state) => {
        state.zustandSync = newState
        }, false, 'SYNC_DATA')
    },
    REMOVE_CREATE_FIELDS: () => {
        set((state) => {
            state.createFields = initialState
        }, false, 'REMOVE_CREATE_FIELDS')
    },
    REMOVE_EDIT_FIELDS: () => {
        set((state) => {
            state.editFields = initialState
        }, false, 'REMOVE_EDIT_FIELDS')
    },
    REMOVE_ALL_FIELDS: () => {
        set((state) => {
            state.createFields = initialState
            state.editFields = initialState
        }, false, 'REMOVE_ALL_FIELDS')
    }
});